import React from "react";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { Props } from "./types";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";
import { ResourcesList } from "./resourcesList";

function GroupEditionForm(props: Props) {
  const { t } = useTranslation();

  return (
    <WorkspaceContext
      {...(props.group.resourceType === "project"
        ? { type: "project", project: props.project }
        : { type: "planzone" })}
    >
      <div className={styles.groupEditionForm}>
        <div className={styles.group}>
          <h3 className={styles.title}>{t("editResourceGroup.form.title")}</h3>
          <input
            className={styles.input}
            value={props.formData.name}
            placeholder={t("editResourceGroup.form.namePlaceholder")}
            onChange={(e) =>
              props.edit({
                ...props.formData,
                name: e.target.value,
              })
            }
            onBlur={() => props.submit(props.formData)}
          />
        </div>
        <ResourcesList
          resources={props.group.resources}
          group={props.group}
          project={props.project}
        />
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("editResourceGroup.form.description")}
          </h3>
          <textarea
            className={styles.textArea}
            placeholder={""}
            value={props.formData.description}
            onChange={({ target }) =>
              props.edit({
                ...props.formData,
                description: target.value,
              })
            }
            onBlur={() => props.submit(props.formData)}
          />
        </div>
      </div>
    </WorkspaceContext>
  );
}

export { GroupEditionForm };
